angular.module('impactx.basket').controller('BasketItemCtrl', [
    '$scope',
    'ColorUtilService',
    'AppConfiguration',
    'TranslationService',
    '$mdDialog',
    'AddToBasketService',
    'ToastService',
    'ProductEuelService',
    BasketItemCtrl
]);

function BasketItemCtrl($scope, ColorUtilService, AppConfiguration, TranslationService, $mdDialog, AddToBasketService, ToastService, ProductEuelService) {
    $scope.Math = window.Math;
    $scope.offSetForSelectColor = 6;
    $scope.offSetForBasketMandatoryColor = 12;
    $scope.offSetForBasketItemGroupColor = 15;
    $scope.addressesLayout = AppConfiguration.get('basketAddressesLayout');
    $scope.controlsLayout = AppConfiguration.get('basketControlsLayout');
    $scope.datesLayout = AppConfiguration.get('basketDatesLayout');
    $scope.showBuyerNoMinimizedBasket = AppConfiguration.get('showBuyerNoMinimizedBasket');
    $scope.fictionalPriceLabel = TranslationService.get("fictionalPrice");
    $scope.productDataSheetLabel = TranslationService.get("productDataSheet");
    this.productEuelService = ProductEuelService;

    if ($scope.basketItem.comments) {
        if ($scope.basketItem.comments.internalComments) {
            $scope.basketItem.comments.internalComments.newComments = [];
        }
        if ($scope.basketItem.comments.externalComments) {
            $scope.basketItem.comments.externalComments.newComments = [];
        }
    }
    $scope.selectBasketItem = function (basketItem, event) {
        if (!$scope.readOnly) {
            if (event.target.tagName != "INPUT" && (event.target.parentNode == null || event.target.parentNode.tagName != "BUTTON")
                && event.target.tagName != "BUTTON" && event.target.tagName != "TEXTAREA" && event.target.tagName != "MD-CHIPS-WRAP"
                && event.target.tagName != "MD-SELECT"
                && event.target.getAttribute("role") != "button") {
                if ($scope.showControl) {
                    $scope.showControl.value = false;
                }
                if ($scope.showAddresses) {
                    $scope.showAddresses.value = false;
                }
                if ($scope.showComments) {
                    $scope.showComments.value = false;
                }
                $scope.selectedBasketSupplier.splice(0, 1);
                if (basketItem.selected) {
                    var index = $scope.selectedBasketItems.indexOf(basketItem);
                    if (index > -1) {
                        $scope.selectedBasketItems.splice(index, 1);
                    }
                }
                else {
                    $scope.selectedBasketItems.push(basketItem);
                }
                basketItem.selected = !basketItem.selected;
            }
        }
    };

    if ($scope.basketItem.infoGroup) {
        var color = ColorUtilService.getColor($scope.basketItem.infoGroup);
        $scope.color = {'border-left-color': color};
    }
    else {
        $scope.color = {'border-left-color': 'transparent'};
    }

    if ($scope.basketItem.selectGroup) {
        var color = ColorUtilService.getColor($scope.basketItem.selectGroup + $scope.offSetForSelectColor);
        $scope.colorSelect = {'border-left-color': color};
    }
    else {
        $scope.colorSelect = {'border-left-color': 'transparent'};
    }

    if ($scope.basketItem.basketMandatoryGroup) {
        var color = ColorUtilService.getColor($scope.basketItem.basketMandatoryGroup + $scope.offSetForBasketMandatoryColor);
        $scope.colorBasketMandatory = {'border-left-color': color};
    }
    else {
        $scope.colorBasketMandatory = {'border-left-color': 'transparent'};
    }

    if ($scope.basketItem.basketItemGroupId) {
        var color = ColorUtilService.getColor($scope.basketItem.basketItemGroupId + $scope.offSetForBasketItemGroupColor);
        $scope.colorBasketItemGroup = {'border-left-color': color};
    }
    else {
        $scope.colorBasketItemGroup = {'border-left-color': 'transparent'};
    }

    $scope.extendBorder = function () {
        var element = document.getElementsByClassName('basket-item-' + $scope.basketItem.infoGroup);
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    $scope.shrinkBorder = function () {
        var element = document.getElementsByClassName('basket-item-' + $scope.basketItem.infoGroup);
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };

    $scope.extendBorderSelect = function () {
        var element = document.getElementsByClassName('basket-item-' + ($scope.basketItem.selectGroup + $scope.offSetForSelectColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    $scope.shrinkBorderSelect = function () {
        var element = document.getElementsByClassName('basket-item-' + ($scope.basketItem.selectGroup + $scope.offSetForSelectColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };

    $scope.extendBorderBasketMandatory = function () {
        var element = document.getElementsByClassName('basket-item-' + ($scope.basketItem.basketMandatoryGroup + $scope.offSetForBasketMandatoryColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    $scope.shrinkBorderBasketMandatory = function () {
        var element = document.getElementsByClassName('basket-item-' + ($scope.basketItem.basketMandatoryGroup + $scope.offSetForBasketMandatoryColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };

    $scope.extendBorderBasketItemGroup = function () {
        var element = document.getElementsByClassName('basket-item-group-' + ($scope.basketItem.basketItemGroupId + $scope.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    $scope.shrinkBorderBasketItemGroup = function () {
        var element = document.getElementsByClassName('basket-item-group-' + ($scope.basketItem.basketItemGroupId + $scope.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };

    this.reject = function (event, bundleItem, basketItem) {
        $scope.rejectItem({event: event, bundleItem: bundleItem, basketItem: basketItem});
    };

    this.unbundle = function (event, bundleItem, basketItem) {
        $scope.unbundleItem({event: event, bundleItem: bundleItem, basketItem: basketItem});
    };

    this.setItemAsChanged = function () {
        $scope.markAsChanged({isValid: $scope.form['basketItem' + $scope.basketItem.id].$valid});
    };

    this.openTimedBaseProductStockDialog = function (event) {
        $mdDialog.show({
            controller: "TimedBaseProductStockDialogCtrl",
            controllerAs: "timedBaseProductStockDialogCtrl",
            templateUrl: "modules/search/templates/timedbaseproduct.dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                product: {id: $scope.basketItem.productId}
            }
        })
    };

    this.changeAat = function (aatId, basketItem, oldAATId) {
        if (oldAATId && impactX.isDefined(basketItem, 'aat.entries')) {
            var oldAATSelected = undefined;
            for (var i = 0; i < basketItem.aat.entries.length; i++) {
                if (basketItem.aat.entries[i].id == oldAATId) {
                    oldAATSelected = basketItem.aat.entries[i];
                    break;
                }
            }
            $scope.changeAat({aatId: aatId, basketItem: basketItem, oldAAT: oldAATSelected});
        }
        else {
            $scope.changeAat({aatId: aatId, basketItem: basketItem});
        }
    };

    $scope.ctrlRequired = {};
    for (var key in $scope.basketItem.control) {
        $scope.ctrlRequired[key] = $scope.basketItem.control[key].showMust;
    }

    this.showControl = function (ctrl, type) {
        return ctrl && (($scope.showControl && $scope.showControl.value && $scope.basketItem && $scope.basketItem.selected) ||
            $scope.ctrlRequired[type] || (ctrl.set && ctrl.set.length > 0));
    };

    this.requireCtrl = function (ctrlString) {
        if ($scope.ignoreAccountingRequired) {
            $scope.ctrlRequired[ctrlString] = false;
        }
        else {
            $scope.ctrlRequired[ctrlString] = $scope.requireCtrl({
                ctrlString: ctrlString,
                basketItem: $scope.basketItem
            });
        }
        return $scope.ctrlRequired[ctrlString];
    };

    $scope.eClassDataArray = [{field: "eClass", value: $scope.basketItem.eClass},
        {field: "sapConfigId", value: $scope.basketItem.sapConfigId}];

    this.anyControlSet = function () {
        if($scope.basketItem.aat && $scope.basketItem.aat.selected) {
            return true
        }
        var ctrl = $scope.basketItem.control;
        for(var key in ctrl) {
            if(ctrl.hasOwnProperty(key) && ctrl[key].set && ctrl[key].set.length > 0) {
                return true;
            }
        }
        return false;
    }

    this.changePayerCom = function (basketItem) {
        $scope.changePayerCompany({basketItem: basketItem});
    };

    this.prgSelected = function (selected) {
        if (selected) {
            $scope.prgSelected({basketItem: $scope.basketItem, selected: selected});
        }
    };

    this.showAttributesDialog = function ($event) {
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        AddToBasketService.showAttributesDialog($scope.basketItem.id, $event).then(function () {
            $scope.getBasket();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        })
    }
}